<div
	class="font-avertareguler w-full h-screen px-2 py-10 md:py-10 md:p-4 bg-white/[67%] dark:bg-slate-900/60 space-y-4 relative"
>
	<div class="flex">
		<h2
			class="text-[#102030] text-[16px] md:text-[20px] font-avertaBold dark:text-white"
		>
			Select Pay types for {{ dayName() }}
		</h2>
	</div>
	<div
		class="space-y-4 popBody scrollbar-thin scrollbar-thumb-[#000733]/20 scrollbar-track-transparent overflow-y-scroll"
	>
		<form class="max-w-sm mx-auto" [formGroup]="paytypeForm">
			<div class="mb-5">
				<label
					for="PayTypes"
					class="block mb-2 text-sm font-medium text-gray-900 dark:text-white flex items-center gap-1"
					>Restrict Pay Types Selected To
					<button
						type="button"
						class="text-yellow-500 hover:text-yellow-600 dark:hover:text-yellow-400 cursor-pointer"
						matTooltip="If no pay types are selected, all pay types are permitted."
						matTooltipPosition="above"
					>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 24 24"
							fill="currentColor"
							class="size-4"
						>
							<path
								fill-rule="evenodd"
								d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
								clip-rule="evenodd"
							/>
						</svg>
					</button>
				</label>
				@if (isLoading()) {
					<div class="text-sm text-gray-500 dark:text-gray-400">
						Loading paytypes...
					</div>
				} @else {
					<app-select-checkbox
						[options]="allPaytypes()"
						placeholder="Select pay types"
						formControlName="PayTypes"
						[minWidth]="'100%'"
					></app-select-checkbox>
				}
			</div>
			<div class="flex justify-end">
				<button
					type="button"
					(click)="onSave()"
					class="py-3 px-6 space-x-1 rounded-full text-[16px] bg-[#010D58] text-[#ffffff] flex items-center dark:bg-gray-950"
				>
					Save
				</button>
			</div>
		</form>
	</div>

	<button
		(click)="closeDialog()"
		type="button"
		class="absolute right-[5px] top-[-12px] h-8 w-8 rounded-full flex justify-center items-center bg-gray-100 text-red dark:bg-white/20 dark:text-white"
	>
		<span>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				fill="none"
				viewBox="0 0 24 24"
				stroke-width="1.5"
				stroke="currentColor"
				class="w-6 h-6"
			>
				<path
					stroke-linecap="round"
					stroke-linejoin="round"
					d="M6 18L18 6M6 6l12 12"
				/>
			</svg>
		</span>
	</button>
</div>
